import contactUsClickCallback from './contactUsClickCallback';

const elementIterator = (el: Node) => {
  el.addEventListener('click', contactUsClickCallback);
};

const registerContactUsClick = () => {
  // This is optimized for our Wordpress pages & Contact Us dropdown
  // If we need to implement this for other repos, this will need to be adjusted
  const dropdownContainers = document.querySelectorAll('.dropdown-menu .flex-wrap');

  if (dropdownContainers.length) {
    dropdownContainers.forEach(container => {
      if (container.innerHTML.indexOf('Send us a message') !== -1) {
        container.childNodes.forEach(innerDiv => {
          innerDiv.childNodes.forEach(child => {
            if (child.nodeName === 'A') {
              elementIterator(child);
            }
          });
        });
      }
    });
  }
};

export default registerContactUsClick;
